import amplitude, { Callback } from "amplitude-js";

export default function initAmplitude() {
  const instance = amplitude.getInstance();

  instance.init(process.env.REACT_APP_AMPLITUDE_API_KEY);

  if (process.env.NODE_ENV === "development") {
    /*
    * override logEvent for development.
    * logEvent does not sent requests. only logged params
    */
    instance.logEvent = (event: string, data?: any, callback?: Callback) => {
      console.groupCollapsed(event);

      // options group
      console.groupCollapsed("options");
      console.dir(instance.options);
      console.groupEnd();

      // data group
      if (data) {
        console.groupCollapsed("data");
        console.log(JSON.stringify(data, null, 2));
        console.groupEnd();
      }

      // options group
      if (callback) {
        console.groupCollapsed("callback");
        console.log(callback.toString());
        console.groupEnd();
      }

      console.groupEnd();
    };
  }

  return instance;
}
